<template lang="html">
  <div class="test-group-question" v-if="question">
    <div class="test-group-question-body">
      <span class="test-group-question-index">{{ index }}.</span> {{ body }}
    </div>
    <div class="test-group-question-picture">
      <img :src="picture" :alt="body"/>
    </div>
    <div class="test-group-question-answers" v-if="answers">
      <Answer v-for="(answer, i) in answersSorted" :key="i" :question="question" :answer="answer" :answerChange="answerChange"/>
    </div>
    <div v-else>
      <!-- no answers message -->
    </div>
  </div>
</template>

<script>
  import Answer from './Answer.vue'

  export default {
    name: 'interview-test-group-question',

    components: {
      Answer
    },

    props: {
      question: Object,
      index: Number,
      answerChange: Function
    },

    data () {
      return {
      }
    },

    methods: {
    },

    computed: {
      body () {
        return this.question ? this.question.body : void 0
      },

      picture () {
        return this.question ? this.question.picture : void 0
      },

      answers () {
        return this.question.answers ? this.question.answers : void 0
      },

      answersSorted () {
        return this.answers.map(item => item).sort((a, b) => a.priority - b.priority)
      }
    },

    beforeMount () {
    }
  }
</script>

<style lang="scss" scoped>
  .test-group-question {
    padding: 32px 0px;

    .test-group-question-body {
      padding: 8px 0px;
      .test-group-question-index {
        font-weight: 700;
      }
    }

    .test-group-question-picture {
      padding: 8px 0px;
    }
  }
</style>
